// import { auth } from "@dotsyntax-pliroforiki/hcn-core";
import jwtDecode from "jwt-decode";
import Config from "../config";
import LocalData from "./LocalData";

const hasAccess = (auth, type, action) => {
  if (auth?.credentials?.is_admin) return true;

  return (
    auth.permissions.find((x) => x.assets[type]?.find((y) => y == action)) !=
    null
  );
};

function hasAssetAccess(auth, asset, type, action) {
  if (auth?.credentials?.is_admin) return true;

  return (
    auth.permissions.find(
      (x) =>
        x.venueId == asset.venueId && x.assets[type]?.find((y) => y == action)
    ) != null
  );
}

const hasAssetAccessProxy = (permissions, type, action, propertyId) => {
  const jwt_access_token = LocalData.get(
    Config.LOCAL_DATA_KEYS.JWT_ACCESS_TOKEN
  );

  const token = jwt_access_token && jwtDecode(jwt_access_token);

  const credentials = token || { is_admin: false };
  if (propertyId) {
    // Use auth.hasPropertyAccess directly with null check
    return hasPropertyAccess?.(
      {
        credentials,
        // permissions: permissions.map(p => ({
        // 	...p,
        // 	propertyId: p.venueId, // Assuming propertyId is the same as venueId
        // })),
        permissions,
      },
      type,
      action,
      propertyId
    );
  } else {
    // console.log('Using default hasAccess:', type, action);
    // Use auth.hasAccess directly with null check
    return hasAccess?.({ credentials, permissions }, type, action);
  }
};

export const Authorize = {
  dinein: {
    read: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "dinein", "R", propertyId),
    readAll: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "dinein", "RA", propertyId),
    edit: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "dinein", "E", propertyId),
  },
  valet: {
    read: (permissions, propertyId) =>
      permissions && hasAssetAccessProxy(permissions, "valet", "R", propertyId),
    readAll: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "valet", "RA", propertyId),
    edit: (permissions, propertyId) =>
      permissions && hasAssetAccessProxy(permissions, "valet", "E", propertyId),
  },
  housekeeping: {
    read: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "housekeeping", "R", propertyId),
    readAll: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "housekeeping", "RA", propertyId),
    edit: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "housekeeping", "E", propertyId),
  },
  amenities: {
    read: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "amenities", "R", propertyId),
    readAll: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "amenities", "RA", propertyId),
    edit: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "amenities", "E", propertyId),
  },
  users: {
    read: (permissions, propertyId) =>
      permissions && hasAssetAccessProxy(permissions, "users", "R", propertyId),
    readAll: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "users", "RA", propertyId),
    edit: (permissions, propertyId) =>
      permissions && hasAssetAccessProxy(permissions, "users", "E", propertyId),
  },
  providers: {
    read: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "providers", "R", propertyId),
    readAll: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "providers", "RA", propertyId),
    edit: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "providers", "E", propertyId),
  },
  tray_pickup: {
    read: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "tray_pickup", "R", propertyId),
    readAll: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "tray_pickup", "RA", propertyId),
    edit: (permissions, propertyId) =>
      permissions &&
      hasAssetAccessProxy(permissions, "tray_pickup", "E", propertyId),
  },
};
